import { IconContainer } from "./EditIcon.styles"

export interface EditIconProps {
    iconSize?: number;
    iconColor?: string;
    containerSize?: number;
    containerBackgroundColor?: string;
    containerBorderColor?: string;
    containerBorderWidth?: number;
    className?: string;
}

const EditIcon: React.FC<EditIconProps> = ({
    iconSize = 10,
    iconColor = "#0022E6",
    containerSize,
    containerBackgroundColor,
    containerBorderColor,
    containerBorderWidth,
    className
}) => {
    return (
        <IconContainer
            className={className}
            $size={containerSize}
            $backgroundColor={containerBackgroundColor}
            $borderColor={containerBorderColor}
            $borderWidth={containerBorderWidth}
        >
            <svg width={iconSize} height={iconSize} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.15147 1.15152C7.6201 0.682892 8.3799 0.682892 8.84853 1.15152C9.31716 1.62015 9.31716 2.37995 8.84853 2.84858L8.37279 3.32431L6.67573 1.62726L7.15147 1.15152Z" fill={iconColor}/>
                <path d="M5.82721 2.47578L0.799999 7.50299V9.20005H2.49705L7.52426 4.17284L5.82721 2.47578Z" fill={iconColor}/>
            </svg>
        </IconContainer>
    )
}

export default EditIcon
